import { Colors } from '~/themes/colors';
import { IIconProps } from './Types';

export const ArrowLeftIcon = ({ color = Colors.secondary_500, size = 24 }: IIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.01777 7.6361L9.63388 13.4102C10.122 13.8362 10.122 14.5269 9.63388 14.9529C9.14573 15.379 8.35427 15.379 7.86612 14.9529L0.366117 8.40749C-0.122039 7.98146 -0.122039 7.29073 0.366117 6.86471L7.86612 0.319254C8.35427 -0.106772 9.14573 -0.106772 9.63388 0.319254C10.122 0.74528 10.122 1.43601 9.63388 1.86203L3.01777 7.6361Z"
        fill={color}
      />
    </svg>
  );
};
